var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Centros de custo","p-read-link":"costsCenters.read.one","p-create-link":"costsCenters.create","p-name":"costsCenters"}})}
var staticRenderFns = []

export { render, staticRenderFns }